var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-container"},[_c('div',{staticClass:"success-msg"},[_c('div',{staticClass:"text"},[_vm._v("授权成功，正在返回业务页面...")])])])
}]

export { render, staticRenderFns }